

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Store, EnterpriseEnvironment, Timing } from '@/models/admin/store';
import { VehicleReviveStepSelectList } from '@/models/inventory/vehiclerevivestep';
import { StoreJson, StoreModel } from '@/models/admin/store';
import { Response } from '@/models/response';
import { Utils } from '@/helper/utils';
import { FileHelper } from '@/helper/file.helper';
import { Base } from '@/components/common/base';
import { FindPoResponse } from '@/Alynk.dtos';
import { storeService, vehicleReviveStepsService, userService } from '@/shared';
import { RoleType } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {},
})
export default class SaveStoreInfoPage extends Base {
  public storeViewModel: any = {};
  public storeJson: any = {
    mainPhonePrefix: '1',
    servicePhonePrefix: '1',
    isEnabled: true
  };
  public showTimer: boolean = false;
  public serviceFile: any;
  public isEnableStore: boolean = false;
  public form: any = {};
  public storeInfoFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public fileRef: any;
  public attachments: any = [];
  public attachmentsCsv: any = [];
  public files: any = [];
  public csvFiles: any = [];
  public selectedFile: any;
  public environment: EnterpriseEnvironment;
  public reviveStepsNew: VehicleReviveStepSelectList[];
  public reviveStepsUsed: VehicleReviveStepSelectList[];
  public isShowCount: boolean = false;
  public isShowCustomValues: boolean = false;
  public users: any[] = [];


  public jpmcJournalCode?: any[] = [
    {
      text: "CDH",
      value: 'CDH',
    },
    {
      text: "VIR",
      value: 'VIR',
    },
    {
      text: "CDP",
      value: 'CDP',
    }
  ];

  public paymentProviders?: any[] = [
    {
      text: this.$parent.$t('stores.info.paymentProviders.vantiv') as string,
      value: 'Vantiv',
    },
    {
      text: this.$parent.$t('stores.info.paymentProviders.cenpos') as string,
      value: 'Cenpos',

    },
    {
      text: this.$parent.$t('stores.info.paymentProviders.square') as string,
      value: 'Square',
    },
    {
      text: this.$parent.$t('stores.info.paymentProviders.clover') as string,
      value: 'Clover',
    },
    {
      text: 'Payroc',
      value: 'Payroc',
    },
    {
      text: 'AuthorizeNet',
      value: 'AuthorizeNet',
    },
    {
      text: 'Redrock',
      value: 'Redrock',
    }
  ];

  public vendorPaymentProviderItems?: any[] = [
    {
      text: "RePay",
      value: 'RePay',
    },
    {
      text: "CheckBookIo",
      value: 'CheckBookIo',
    },
  ];

  public ocrProviderList?: any[] = [
    {
      text: "SuperAi",
      value: 'SuperAi',
    },
    {
      text: "Butler",
      value: 'Butler',
    },

  ];
  public creditCards?: any[] = [
    {
      text: "Ramp",
      value: 'Ramp',
    },
    {
      text: "Privacy",
      value: 'Privacy',
    },
  ];

  public letterProvider?: any[] = [
    {
      text: 'Click Send',
      value: 'ClickSend',
    },
    {
      text: 'LOB',
      value: 'LOB',
    },
  ];

  public stockLogicOption?: any[] = [
    {
      text: 'Last of Vin',
      value: 'LastOfVin',
    },
    {
      text: 'Custom Value',
      value: 'CustomValue',
    },
  ];

  public faxProviders?: any[] = [
    {
      text: this.$parent.$t('stores.info.faxProviders.twilio') as string,
      value: 'Twilio',
    },
    {
      text: this.$parent.$t('stores.info.faxProviders.Documo') as string,
      value: 'Documo',
    },
  ];
  public requestProgress: boolean = false;

  public created(): void {
    this.setStoreInfoFields();
    this.addWatchers();
  }
  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: {
            id: this.storeId.toString(),
            tab: 'Info'
          },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'backToStoreAdd') {
      this.$router
        .push({
          name: 'admin.stores',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            tab: 'Info',
          },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.info.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveStore();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateFiledValus(val) {
    this.formlyShowSkeleton(this.storeInfoFields);
    this.isShowCount = val != undefined && val == 'LastOfVin' ? true : false;
    (this.isShowCustomValues =
      val != undefined && val == 'CustomValue' ? true : false),
      this.setStoreInfoFields();
    this.formlyHideSkeleton(this.storeInfoFields);
  }

  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    } else {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreAdd',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public async mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'stores');

    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getReviveSteps();
      await this.getStoreInfo(this.storeId);
      await this.getUsers();
    }
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    var role = [RoleType.TenantAdmin.toString(), RoleType.EnterpriseAdmin.toString(), RoleType.SuperAdmin.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.isEnableStore = isRoleAllowed.includes('SuperAdmin') || isRoleAllowed.includes('T-Admin') || isRoleAllowed.includes('E-Admin');

    this.setStoreInfoFields();
  }
  public addWatchers() {
    this.$watch('storeJson.glStoreId', (newVal, oldVal) => {
      if (newVal) {
        const fileField = this.storeInfoFields.find((f) => {
          return f.key === 'logoUri';
        });
        if (fileField) {
          fileField.templateOptions.action =
            Utils.API_BASE_URL +
            `/stores/uploadlogo/${this.storeJson.name}/${newVal}`;
        }
      }
    });
    this.$watch('storeJson.name', (newVal, oldVal) => {
      if (newVal) {
        const fileField = this.storeInfoFields.find((f) => {
          return f.key === 'logoUri';
        });
        if (fileField) {
          fileField.templateOptions.action =
            Utils.API_BASE_URL +
            `/stores/uploadlogo/${newVal}/${this.storeJson.glStoreId}`;
        }
      }
    });
  }
  get days(): string {
    if (this.timingModel) {
      return this.timingModel.from + '-' + this.timingModel.to;
    }
    return '';
  }
  public timingModel: Timing = {
    days: this.days,
    to: '',
    from: '',
    startTime: '00:00',
    endTime: '00:00',
  };
  public setStoreInfoFields(): void {
    this.storeInfoFields = [
      {
        key: "wrapperHeading1",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Store Details</h2></span>'
      },
      {
        key: 'glCompanyId',
        required: true,
        type: 'v-alynk-companies',
        templateOptions: {
          disabled: false,
          multiple: false,
          required: true,
          label: this.$t('stores.info.InfoFields.glCompany') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v => this.required('Gl Company', v)
          ]
        },
      },
      {
        key: 'glStoreId',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.info.InfoFields.storeId') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left pl-0',
          rules: [
            v => this.required('Store Id', v)
          ]
        },
      },
      {
        key: 'name',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.dealershipName') as string,
          required: true,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.required('Dealership Name', v)
          ]
        },
      },
      {
        key: 'franchiseCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.franchiseCode') as string,
          counter: 10,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'merchantEmail',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.MerchantEmail') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.Email(v)
          ]
        },
      },
      {
        key: 'websiteUrl',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.websiteUrl') as string,
          validations: 'url',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-2 pl-0 float-left',
        },
      },
      {
        key: 'isEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          display: this.isEnableStore,
          disabled: false,
          required: false,
          label: 'Is Enable Store',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-3 float-left',
        },
      },
      {
        key: "wrapperHeading2",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Contact Numbers</h2></span>'
      },
      {
        key: 'mainPhonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 2,
          label: this.$t('stores.info.InfoFields.prefix') as string,
          required: false,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-5 py-0 pl-0 float-left',
          loading: false,
          rules: [
            v => this.required('Prefix', v)
          ]
        },
      },

      {
        key: 'mainPhone',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.mainDealershipPhone'
          ) as string,
          counter: 10,
          hint: Utils.PhoneNoHint,
          mask: this.phoneMask,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 pl-0 float-left',
          loading: false,
          rules: [
            v => this.PhoneNumber(v)
          ]
        },
      },
      {
        key: 'servicePhonePrefix',
        type: 'v-alynk-phone-field',
        required: false,
        templateOptions: {
          counter: 2,
          label: this.$t('stores.info.InfoFields.prefix') as string,
          required: false,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-5 py-0 pl-0 float-left',
          loading: false,
          rules: [
            v => this.required('Prefix', v)
          ]
        },
      },
      {
        key: 'servicePhone',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.servicePhone') as string,
          counter: 10,
          hint: Utils.PhoneNoHint,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 py-0 pl-0 float-left',
          loading: false,
          rules: [
            v => this.PhoneNumber(v)
          ]
        },
      },
      {
        key: "wrapperHeading3",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">DMS Account Config</h2></span>'
      },
      {
        key: "wrapperHeading4",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Ecomm Credit Card</h3></span>'
      },
      {
        key: 'eccClearingAccountNumber',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.ecommCreditCardClearingAccount'
          ) as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'eccClearingControlNumber',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.ecommCreditCardClearingControl'
          ) as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading5",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Deal AR</h3></span>'
      },
      {
        key: 'dealArAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.dealArAccount') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'dealArControl',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.dealArControl') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading6",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">RO</h3></span>'
      },
      {
        key: 'roAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Ro Account #',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'roControl',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Ro Control #',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'roDeductibleAccontNumber',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Ro Deductible #',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading7",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Part Sale</h3></span>'
      },
      {
        key: 'partSaleAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'PartSale Account #',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'partSaleControl',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'PartSale Control #',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading8",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Deposit Log</h3></span>'
      },
      {
        key: 'depositLogAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.depositLogAccount') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'depositLogControl',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.depositLogControl') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      // {
      //   key: 'lastReceiptNumber',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     label: this.$t('stores.info.InfoFields.lastReceiptNumber') as string,
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },
      {
        key: 'depositLogMoveAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.depositLogMoveAccount'
          ) as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading9",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections" style="margin-top: 11%;">Payment Info</h2></span>'
      },
      {
        key: "wrapperHeading10",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Card Payment Config</h3></span>'
      },
      {
        key: 'vendorPaymentBankAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.vendorPaymentBankAccount'
          ) as string,
          counter: 30,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'vendorPaymentApiKey',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.vendorPaymentApiKey'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0  float-left',
        },
      },
      {
        key: 'defaultCardProvider',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: "Default Credit Card",
          text: 'text',
          value: 'value',
          items: this.creditCards,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'rampClientId',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Ramp Provider Api Client Id',
          counter: 150,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'rampClientSecret',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Ramp Provider Api Client Secret',
          counter: 250,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'cardControlNumber',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Control Number',
          counter: 250,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      // {
      //   key: 'cardDocumentNumber',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     required: false,
      //     label: 'Card Doc Number',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },

      {
        key: "wrapperHeading11",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Vendor Default Payment Provider Config</h2></span>'
      },
      {
        key: 'vendorDefaultPaymentProvider',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: "Vendor Default Payment Provider",
          text: 'text',
          value: 'value',
          items: this.vendorPaymentProviderItems,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading12",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Vendor Checkbook Config</h3></span>'
      },
      {
        key: 'checkbookPaymentBankAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.vendorCheckbookPaymentBankAccount'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'checkbookApiKey',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.vendorCheckbookApiKey'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'checkbookApiSecret',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.vendorCheckbookApiSecret'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'checkbookWebhookKey',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.vendorCheckbookWebhookKey'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'checkbookApiUrl',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.checkbookApiUrl') as string,
          counter: 100,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },

      {
        key: "wrapperHeading13",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Repay Config</h2></span>'
      },
      {
        key: 'repayGroupName',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Repay Group Name',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-2 float-left',
        },
      },
      {
        key: 'repayCustomerId',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Repay Customer Id',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n3 float-left',
        },
      },
      {
        key: 'repayHostUri',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Host Uri',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'repayClientId',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Client Id',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'repayClientSecret',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Client Secret',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'repayGroupAmountLimit',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Repay Group Amount Limit',
          loading: false,
          type: 'number',
          counter: 10,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'isAllowRepayGroupAutoApprove',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: "Allow RepayGroup Auto Approve",
          disabled: false,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
          events: {
            onChange: (val) => {
              this.showTimer = val;
              this.setStoreInfoFields();

            },
          },
        },
      },
      {
        key: 'repayGroupAutoApproveTime',
        required: false,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: !this.showTimer,
          display: false,
          label: 'Repay Group Auto Approve Time',
          events: {
            onChange: (val) => {
              this.timingModel.startTime = this.$moment(val, 'HH:mm').format(
                'hh:mm A'
              );
            },
          },
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: "wrapperHeading14",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">OCR Config</h2></span>'
      },
      {
        key: 'defaultOcrProvider',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: "Default Ocr Provider",
          text: 'text',
          value: 'value',
          items: this.ocrProviderList,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ocrApiKey',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'SuperAi Api Key',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ocrUri',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'SuperAi Uri',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0  float-left',
        },
      },
      {
        key: 'apInvoiceProjectId',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'AP Invoice Project Id',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'vehicleProjectId',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Vehicle Invoice Project Id',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },

      {
        key: "wrapperHeading15",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Payment Providers</h2></span>'
      },
      {
        key: 'defaultPaymentProvider',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.defaultPaymentProviderLabel'
          ) as string,
          text: 'text',
          value: 'value',
          items: this.paymentProviders,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'defaultLetterProvider',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: 'Default Letter Provider',
          text: 'text',
          value: 'value',
          items: this.letterProvider,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'defaultFaxProvider',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.defaultFaxProviderLabel'
          ) as string,
          text: 'text',
          value: 'value',
          items: this.faxProviders,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading16",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Credit Card Config</h3></span>'
      },
      {
        key: 'creditCardBankAccount',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Credit Card Bank Account',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-2 float-left',
        },
      },
      {
        key: 'creditCardFees',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Credit Card Fees',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n3 float-left',
        },
      },
      {
        key: "wrapperHeading17",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Registration Step</h2></span>'
      },
      {
        key: 'vehicleRegReviveStepNew',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.registrationStepForNewVehicleRevive'
          ) as string,
          text: 'name',
          value: 'id',
          items: this.reviveStepsNew,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'vehicleRegReviveStepUsed',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.registrationStepForUsedVehicleRevive'
          ) as string,
          text: 'name',
          value: 'id',
          items: this.reviveStepsUsed,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading18",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Inspection Step</h2></span>'
      },
      {
        key: 'vehicleInspectionReviveStepNew',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.inspectionStepForNewVehicleRevive'
          ) as string,
          text: 'name',
          value: 'id',
          items: this.reviveStepsNew,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'vehicleInspectionReviveStepUsed',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: this.$t(
            'stores.info.InfoFields.inspectionStepForUsedVehicleRevive'
          ) as string,
          text: 'name',
          value: 'id',
          items: this.reviveStepsUsed,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading19",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Vehicle Invoice</h2></span>'
      },
      // {
      //   key: 'vehicleInvoiceLocation',
      //   required: false,
      //   type: 'v-alynk-select',
      //   templateOptions: {
      //     required: false,
      //     disabled: false,
      //     validations: '',
      //     label: 'Vehicle Invoice Location',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n2 float-left' ,
      //   },
      // },
      {
        key: 'vehicleInvoiceLocation',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Vehicle Invoice Location',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-2 float-left',
        },
      },
      {
        key: 'vehicleInvoiceMake',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          display: false,
          disabled: false,
          required: false,
          label: 'Vehicle Invoice Make',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n3 float-left',
        },
      },
      {
        key: "wrapperHeading20",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Work Day Location</h2></span>'
      },
      {
        key: 'workDayLocation',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Work Day Location',
          counter: 150,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-3 float-left',
        },
      },
      {
        key: "wrapperHeading21",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">WeareSalty</h2></span>'
      },
      {
        key: 'weareSaltyOrganiazationId',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'WeareSalty OrganiazationId',
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-3 float-left',
        },
      },
      {
        key: 'isWeareSaltySyncEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Enable WeareSalty Sync',
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      // {
      //   key: null,
      //   type: 'v-alynk-label',
      //   templateOptions: {
      //     disabled: true,
      //     label: '',
      //   },
      //   wrapper:'<span class="col-12"><h2 class="storeSections">Doc Number</h2></span>'
      // },
      // {
      //   key: 'reconcilationDocNumber',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     required: false,
      //     label: 'Reconcilation Doc Number',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-4 float-left',
      //   },
      // },
      // {
      //   key: 'roDeductibleDocNumber',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     required: false,
      //     label: 'Ro Deductible Doc Number',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n1 float-left',
      //   },
      // },
      // {
      //   key: 'vehicleDocumentNumber',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     required: false,
      //     label: 'Vehicle Doc Number',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },
      // {
      //   key: 'vehicleInvoiceNumber',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     required: false,
      //     label: 'Vehicle Invoice Number',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },
      {
        key: "wrapperHeading22",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Vehicle Stocked Email</h2></span>'
      },
      {
        key: 'vehicleStockedEmail',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Vehicle Stocked Email',
          type: 'email',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-3 float-left',
          rules: [
            v => this.Email(v)
          ]
        },
      },
      {
        key: "wrapperHeading23",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Flooring Report Setup</h2></span>'
      },
      {
        key: 'flooringReportUsersEmail',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Flooring Report Users Email',
          text: 'email',
          value: 'id',
          items: this.users,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading24",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Stock Number Logic</h2></span>'
      },
      {
        key: 'stockNumberLogic',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          required: false,
          disabled: false,
          label: 'Stock Number Logic',
          text: 'text',
          value: 'value',
          items: this.stockLogicOption,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          events: {
            onChange: (item, val) => {
              this.updateFiledValus(val);
            },
          },
        },
      },
      {
        key: 'vinDigitCount',
        required: false,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: !this.isShowCount,
          label: 'Vin Digit Count',
          text: 'text',
          value: 'value',
          items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'stockPreAppendValue',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: this.isShowCustomValues,
          label: 'Stock Pre Append Text',
          counter: 100,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0  float-left',
        },
      },
      {
        key: 'evStockPreAppendValue',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: this.isShowCustomValues,
          label: 'Electric Vehicle Stock Pre Append Text',
          counter: 100,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0  float-left',
        },
      },
      {
        key: "wrapperHeading25",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Whole Vehicle Transfer</h2></span>'
      },
      {
        key: 'wholeSaleVehiclePreAppendStockValue',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          //display: this.isShowCustomValues,
          label: 'WholeSale Stock Pre Append Text',
          counter: 100,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-6 mb-3 float-left',
        },
      },
      {
        key: "wrapperHeading28",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Journal Code Configuration</h2></span>'
      },
      {
        key: 'repayJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Repay Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-2 float-left',
        },
      },
      {
        key: 'vehicleWholeInBoundStoreJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Vehicle WholeSale InBound Store JournalCode',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n3 float-left',
        },
      },
      {
        key: 'vehicleCpoGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Vehicle Cpo GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'workDayJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'WorkDay Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'reconcileGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Reconcile GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'dealGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Deal Gl Post Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'arGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Ar GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'depositGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Deposit GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'partSaleGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Part Sale GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'repairOrderGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Repair Order GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'repairOrderDeductibleJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Repair Order Deductible Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'adHocGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'AdHoc GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'depositMoveFundJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Deposit Move Fund Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'vendorGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Vendor GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'vendorCheckBookGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Vendor Checkbook GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'vendorRecurringGlPostJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Vendor Recurring GlPost Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'expenseJournalCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Expense Journal Code',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'positivePayUploadJournalCode',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'JPMC Upload Journal Code List',
          text: 'text',
          value: 'value',
          items: this.jpmcJournalCode,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading26",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Bot Config</h32</span>'
      },
      {
        key: 'storeKey',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: false,
          label: 'Store Key',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-2 float-left',
        },
      },
      {
        key: 'dealerCode',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Dealer Code',
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-3 float-left',
        },
      },
      {
        key: 'isAllowAppointment',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          required: false,
          label: 'Allow Access Of XTime Api',
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      // {
      //   key: "wrapperHeading4",
      //   type: 'v-alynk-label',
      //   templateOptions: {
      //     disabled: true,
      //     label: '',
      //   },
      //   wrapper: '<span class="col-12"><h3 class="storeSections subHeading">Payroc Config Environment</h3></span>'
      // },
      // {
      //   key: 'payrocConfigEnvironment',
      //   required: false,
      //   type: 'v-alynk-select',
      //   templateOptions: {
      //     required: false,
      //     disabled: false,
      //     label: "Payroc Config Environment",
      //     text: 'text',
      //     value: 'value',
      //     items: [
      //     { text: 'Production', value: 'Production' },
      //     { text: 'Sandbox', value: 'Sandbox' }
      //               ],
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },
      {
        key: 'prompt',
        required: false,
        type: 'v-alynk-textarea',
        templateOptions: {
          disabled: false,
          label: 'Chat Prompt',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-2 float-left',
        },
      },
      {
        key: 'LaborOpCodeFilePath',
        required: false,
        type: 'v-alynk-file-upload',
        templateOptions: {
          disabled: false,
          label: 'Labor Op Code File',
          required: true,
          multiple: false,
          validations: 'required',
          filetype: 'text',
          events: {
            onChange: (files, ref) => {
              this.csvFiles = files;
              if (files.length > 0) {
                if (files[0].file.type == 'text/csv' || files[0].file.type == 'csv') {
                  this.fileRef = ref;

                  this.getFileBytesForCsv((base64) => {
                    this.storeJson.LaborOpCodeFilePath = base64;
                  });


                } else {
                  this.showAlert(
                    false,
                    'Please upload csv files'
                  );
                  ref.clear();
                }
              }
            },

          },
        },
      },
      {
        key: "wrapperHeading27",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Upload Files</h32</span>'
      },
      {
        key: 'logoUri',
        required: false,
        type: 'v-alynk-file-upload',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.storeLogo') as string,
          required: true,
          multiple: false,
          validations: 'required',
          filetype: 'picture',
          events: {
            onChange: (files, ref) => {

              this.files = files;
              if (files.length > 0) {
                if (files[0].file.type.indexOf('image') > -1) {
                  this.fileRef = ref;
                  this.selectedFile = files[0];
                } else {
                  this.showAlert(
                    false,
                    this.$t('stores.info.alertLogoMustBeValidImage')
                  );
                  ref.clear();
                }
              }
            },
            onSuccess: (res: Response<string>) => {

              if (res.status) {
                this.storeJson.logoUri = res.data.replace(
                  this.$root.$data.environment.blobUrl,
                  ''
                );
                this.saveStoreInfo();
              }
            },
          },
        },
      },
      {
        key: 'introVideoUri',
        required: false,
        type: 'v-alynk-file-upload',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.info.InfoFields.introductionVideo') as string,
          required: true,
          multiple: false,
          validations: 'required',
          filetype: 'picture',
          events: {
            onChange: (files, ref) => {
              this.files = files;
              if (files.length > 0) {
                if (files[0].file.type.indexOf('video') > -1) {
                  this.fileRef = ref;
                  this.selectedFile = files[0];
                } else {
                  this.showAlert(
                    false,
                    this.$t('stores.info.alertLogoMustBeValidVideo')
                  );
                  ref.clear();
                }
              }
            },
            onSuccess: (res: Response<string>) => {
              if (res.status) {
                this.storeJson.introVideoUri = res.data.replace(
                  this.$root.$data.environment.blobUrl,
                  ''
                );
                this.saveStoreInfo();
              }
            },
          },
        },
      },
    ];
  }

  public saveStore() {
    if (this.validateStore().validate()) {
      const data = this.getFileBytes((base64) => {
        this.storeViewModel.attachments = this.attachments;
        this.saveStoreInfo();
      });
    }
  }

  public getFileBytes(callback) {
    this.attachments = [];
    if (!this.files || this.files.length <= 0) {
      callback('');
      return;
    }
    for (let i = 0; i < this.files.length; i++) {
      if (!this.files[i]) {
        continue;
      }
      if (!this.files[i].file) {
        continue;
      }

      if (this.files.length === i + 1) {

        const extension = this.files[i].file.name.substring(
          this.files[i].file.name.lastIndexOf('.')
        );
        const fileBytes = FileHelper.getAttachments(
          this.files[i].file,
          extension,
          this.attachments,
          callback
        );
      } else {

        const extension = this.files[i].file.name.substring(
          this.files[i].file.name.lastIndexOf('.')
        );
        const fileBytes = FileHelper.getAttachments(
          this.files[i].file,
          extension,
          this.attachments,
          null
        );
      }
    }
  }


  public getFileBytesForCsv(callback) {
    this.attachmentsCsv = [];
    if (!this.csvFiles || this.csvFiles.length <= 0) {
      callback('');
      return;
    }
    for (let i = 0; i < this.csvFiles.length; i++) {
      if (!this.csvFiles[i]) {
        continue;
      }
      if (!this.csvFiles[i].file) {
        continue;
      }

      if (this.csvFiles.length === i + 1) {

        const extension = this.csvFiles[i].file.name.substring(
          this.csvFiles[i].file.name.lastIndexOf('.')
        );
        const fileBytes = FileHelper.getAttachments(
          this.csvFiles[i].file,
          extension,
          this.attachmentsCsv,
          callback
        );
      } else {

        const extension = this.csvFiles[i].file.name.substring(
          this.csvFiles[i].file.name.lastIndexOf('.')
        );
        const fileBytes = FileHelper.getAttachments(
          this.csvFiles[i].file,
          extension,
          this.attachmentsCsv,
          null
        );
      }
    }
  }

  public async getReviveSteps(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeInfoFields, 'vehicleRegReviveStepUsed');
      this.formlyShowSkeleton(this.storeInfoFields, 'vehicleRegReviveStepNew');
      const response = await vehicleReviveStepsService.getVehicleReviveStepsSelectList(
        this.storeId
      );
      const reviveSteps = response.results;
      this.reviveStepsNew = reviveSteps.filter((x) => {
        return x.type === 'New';
      });
      this.reviveStepsUsed = reviveSteps.filter((y) => {
        return y.type === 'Used';
      });
      this.setStoreInfoFields();
    } finally {
      this.formlyHideSkeleton(this.storeInfoFields, 'vehicleRegReviveStepUsed');
      this.formlyHideSkeleton(this.storeInfoFields, 'vehicleRegReviveStepNew');
    }
  }

  public validateStore(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  public async saveStoreInfo(): Promise<void> {
    try {
      if (
        this.storeJson.stockNumberLogic === 'CustomValue' &&
        (this.storeJson.stockPreAppendValue == undefined ||
          this.storeJson.stockPreAppendValue == '')
      ) {
        this.showAlert(
          false,
          'Please fill preappend value, It can not be Empty.'
        );
        return;
      }
      if (
        this.storeJson.stockNumberLogic === 'CustomValue' &&
        (!this.storeJson.evStockPreAppendValue)
      ) {
        this.showAlert(
          false,
          'Please fill electric vehicle stock preappend value.'
        );
        return;
      }

      if (
        this.storeJson.stockNumberLogic === 'LastOfVin' &&
        (this.storeJson.vinDigitCount == undefined ||
          this.storeJson.vinDigitCount == 0)
      ) {
        this.showAlert(false, 'Vin Digit Count can not be Empty.');
        return;
      }
      if (
        this.storeJson.isAllowRepayGroupAutoApprove &&
        (!this.storeJson.repayGroupAutoApproveTime)
      ) {
        this.showAlert(
          false,
          'Please fill Repay Group Auto Approve Time value, It can not be Empty.'
        );
        return;
      }
      const sjson: StoreJson = {
        name: this.storeJson.Name,
        glStoreId: this.storeJson.glStoreId,
        glCompanyId: this.storeJson.glCompanyId,
        logoUri: this.storeJson.logoUri,
        introVideoUri: this.storeJson.introVideoUri,
        mainPhone: this.storeJson.mainPhone,
        merchantEmail: this.storeJson.merchantEmail,
        servicePhone: this.storeJson.servicePhone,
        status: this.storeJson.status,
        timeZone: this.storeJson.timeZone,
        websiteUrl: this.storeJson.websiteUrl,
        eccClearingAccountNumber: this.storeJson.eccClearingAccountNumber,
        eccClearingControlNumber: this.storeJson.eccClearingControlNumber,
        dealArAccount: this.storeJson.dealArAccount,
        dealArControl: this.storeJson.dealArControl,
        depositLogAccount: this.storeJson.depositLogAccount,
        depositLogControl: this.storeJson.depositLogControl,
        lastReceiptNumber: this.storeJson.lastReceiptNumber,
        vendorPaymentApiKey: this.storeJson.vendorPaymentApiKey,
        vendorPaymentBankAccount: this.storeJson.vendorPaymentBankAccount,
        checkbookApiKey: this.storeJson.checkbookApiKey,
        checkbookApiSecret: this.storeJson.checkbookApiSecret,
        checkbookWebhookKey: this.storeJson.checkbookWebhookKey,
        checkbookPaymentBankAccount: this.storeJson.checkbookPaymentBankAccount,
        checkbookApiUrl: this.storeJson.checkbookApiUrl,
        address: this.storeJson.address,
        pdiJson: this.storeJson.pdiJson,
        vehicleLocations: this.storeJson.vehicleLocations,
        faxLines: this.storeJson.faxLines,
        crossCompanyPostingConfigs: this.storeJson.crossCompanyPostingConfigs,
        checkbookBankAccountJson: this.storeJson.checkbookBankAccountJson,
        franchiseCode: this.storeJson.franchiseCode,
        mainPhonePrefix: this.storeJson.mainPhonePrefix,
        servicePhonePrefix: this.storeJson.servicePhonePrefix,
        vehicleRegReviveStepNew: this.storeJson.vehicleRegReviveStepNew,
        vehicleRegReviveStepUsed: this.storeJson.vehicleRegReviveStepUsed,
        vehicleInspectionReviveStepNew: this.storeJson
          .vehicleInspectionReviveStepNew,
        vehicleInspectionReviveStepUsed: this.storeJson
          .vehicleInspectionReviveStepUsed,
        defaultPaymentProvider: this.storeJson.defaultPaymentProvider,
        vendorDefaultPaymentProvider: this.storeJson.defaultPaymentProvider,
        defaultLetterProvider: this.storeJson.defaultLetterProvider,
        repayCustomerId: this.storeJson.repayCustomerId,
        repayGroupName: this.storeJson.repayGroupName,
        repayGroupAmountLimit: this.storeJson.repayGroupAmountLimit,
        // lobPublishKey: this.storeJson.lobPublishKey,
        // lobSecretkey: this.storeJson.lobSecretkey,
        creditCardBankAccount: this.storeJson.creditCardBankAccount,
        creditCardFees: this.storeJson.creditCardFees,
        reconcilationDocNumber: this.storeJson.reconcilationDocNumber,
        roDeductibleDocNumber: this.storeJson.roDeductibleDocNumber,
        vehicleDocumentNumber: this.storeJson.vehicleDocumentNumber,
        vehicleStockedEmail: this.storeJson.vehicleStockedEmail,
        defaultFaxProvider: this.storeJson.defaultFaxProvider,
        stockNumberLogic: this.storeJson.stockNumberLogic,
        vinDigitCount: this.storeJson.vinDigitCount,
        stockPreAppendValue: this.storeJson.stockPreAppendValue,
        evStockPreAppendValue: this.storeJson.evStockPreAppendValue,
        rampClientId: this.storeJson.rampClientId,
        rampClientSecret: this.storeJson.rampClientSecret,
        defaultCardProvider: this.storeJson.defaultCardProvider,
        cardControlNumber: this.storeJson.cardControlNumber,
        // stockSequenceNumber: this.storeJson.stockSequenceNumber,
        vehicleInvoiceLocation: this.storeJson.vehicleInvoiceLocation,
        isEnabled: this.storeJson.isEnabled,
        flooringReportUsersEmail: this.storeJson.flooringReportUsersEmail,
        storeKey: this.storeJson.storeKey,
        ocrApiKey: this.storeJson.apiKey,
        ocrUri: this.storeJson.uri,
        apInvoiceProjectId: this.storeJson.apInvoiceProjectId,
        vehicleProjectId: this.storeJson.vehicleProjectId,
        payrocConfigEnvironment: this.storeJson.payrocConfigEnvironment
      };
      if (this.storeJson.mainPhone.length === 10) {
        this.storeJson.mainPhone =
          '+' + this.storeJson.mainPhonePrefix + this.storeJson.mainPhone;
      }
      if (this.storeJson.servicePhone.length === 10) {
        this.storeJson.servicePhone =
          '+' + this.storeJson.servicePhonePrefix + this.storeJson.servicePhone;
      }

      this.requestProgress = true;
      this.$emit('update:progress', this.requestProgress);
      this.storeViewModel.storeJson = this.storeJson;
      this.setStoreInfoFields();
      const keys = Object.keys(this.storeJson);
      keys.forEach((key) => {
        let value = this.storeJson[key];
        if (key == "flooringReportUsersEmail") {
          value = value.toString();
          this.storeViewModel.storeJson.flooringReportUsersEmail = value.length > 0 ? value.split(',') : [];
        }
      });
      this.storeViewModel.isEnabled = this.storeJson.isEnabled;
      if (this.storeId) {
        const response = await storeService.updateStoreInfo(
          this.storeViewModel,
          this.storeId
        );
        this.storeViewModel = response;
        this.showAlert(true, this.$t('stores.info.alertStoreInfoUpdated'));
        this.$router
          .push({
            name: 'admin.stores.edit',
            params: {
              tenantId: this.tenantId.toString(),
              enterpriseId: this.enterpriseId.toString(),
              storeId: this.storeViewModel.id.toString(),
              tab: 'Info'
            },
          })
          .catch((ex) => {
            console.log(ex);
          });
      } else {
        const response = await storeService.saveStoreInfo(this.storeViewModel);
        this.storeViewModel = response;
        this.showAlert(true, this.$t('stores.info.alertStoreInfoSaved'));
        this.$router
          .push({
            name: 'admin.stores.edit',
            params: {
              tenantId: this.tenantId.toString(),
              enterpriseId: this.enterpriseId.toString(),
              storeId: this.storeViewModel.id.toString(),
              tab: 'Info'
            },
          })
          .catch((ex) => {
            console.log(ex);
          });
      }
    } finally {
      this.requestProgress = false;
      this.$emit('update:progress', this.requestProgress);
    }
  }
  public async getStoreInfo(storeId): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeInfoFields);
      const response = await storeService.getStoreInfo(storeId);
      this.storeViewModel = response;
      this.storeJson.isEnabled = response.isEnabled;
      let disabledMainPhone = true;
      let disabledServicePhone = true;
      if (this.storeViewModel && this.storeViewModel.storeJson && this.storeViewModel.storeJson.isAllowRepayGroupAutoApprove) {
        this.showTimer = true;
        this.setStoreInfoFields();
      }
      this.isShowCount =
        response.storeJson.stockNumberLogic == 'LastOfVin' ? true : false;
      (this.isShowCustomValues =
        response.storeJson.stockNumberLogic == 'CustomValue' ? true : false),
        this.setStoreInfoFields();

      // prefix change
      if (this.storeViewModel.storeJson.mainPhone.length >= 10) {
        this.storeViewModel.storeJson.mainPhone = this.storeViewModel.storeJson.mainPhone.replace(
          '+',
          ''
        );
        const mainPhone = this.storeViewModel.storeJson.mainPhone;
        this.storeViewModel.storeJson.mainPhone = mainPhone.substring(
          mainPhone.length,
          mainPhone.length - 10
        );
        this.storeViewModel.storeJson.mainPhonePrefix = mainPhone.substring(
          mainPhone.length - 10,
          0
        );
        if (!this.storeViewModel.storeJson.mainPhonePrefix) {
          this.storeViewModel.storeJson.mainPhonePrefix = '1';
        }
        disabledMainPhone =
          this.storeViewModel.storeJson.mainPhonePrefix === '1';
      }
      if (this.storeViewModel.storeJson.servicePhone.length >= 10) {
        this.storeViewModel.storeJson.servicePhone = this.storeViewModel.storeJson.servicePhone.replace(
          '+',
          ''
        );
        const servicePhone = this.storeViewModel.storeJson.servicePhone;
        // tslint:disable-next-line:max-line-length
        this.storeViewModel.storeJson.servicePhone = servicePhone.substring(
          servicePhone.length,
          servicePhone.length - 10
        );
        this.storeViewModel.storeJson.servicePhonePrefix = servicePhone.substring(
          servicePhone.length - 10,
          0
        );
        if (!this.storeViewModel.storeJson.servicePhonePrefix) {
          this.storeViewModel.storeJson.servicePhonePrefix = '1';
        }
        disabledServicePhone =
          this.storeViewModel.storeJson.servicePhonePrefix === '1';
      }

      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.storeInfoFields.length; i++) {
        if (this.storeInfoFields[i].key === 'mainPhonePrefix') {
          this.storeInfoFields[i].templateOptions.disabled = disabledMainPhone;
        }
        if (this.storeInfoFields[i].key === 'servicePhonePrefix') {
          this.storeInfoFields[
            i
          ].templateOptions.disabled = disabledServicePhone;
        }
      }
      for (const prop of Object.keys(this.storeViewModel.storeJson)) {
        this.storeJson[prop] = this.storeViewModel.storeJson[prop];
        if (this.storeViewModel.storeJson[prop] == null) {
          this.storeJson[prop] = '';
        }
      }
    } finally {
      this.formlyHideSkeleton(this.storeInfoFields);
    }
  }


  public async getUsers(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeInfoFields);
      const storeUsers = await userService.getStoreUsers(this.storeId);
      this.users = storeUsers.results;
      this.setStoreInfoFields();
    } finally {
      this.formlyHideSkeleton(this.storeInfoFields);
    }
  }
}
